__turbopack_context__.v({
  "card": "index-module-scss-module__zxcKOq__card",
  "cardContent": "index-module-scss-module__zxcKOq__cardContent",
  "cardLink": "index-module-scss-module__zxcKOq__cardLink",
  "cardMeta": "index-module-scss-module__zxcKOq__cardMeta",
  "cardTitle": "index-module-scss-module__zxcKOq__cardTitle",
  "thumbnail": "index-module-scss-module__zxcKOq__thumbnail",
  "thumbnailContainer": "index-module-scss-module__zxcKOq__thumbnailContainer",
  "updateTag": "index-module-scss-module__zxcKOq__updateTag",
});
